var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#fff","fillRule":"evenodd","d":"M15.354 25h-3.088v-7.5h-1.544v-2.585h1.543v-1.552c0-2.109.871-3.363 3.347-3.363h2.06v2.585h-1.287c-.964 0-1.028.362-1.028 1.036l-.004 1.293h2.334l-.273 2.585h-2.061V25z","clipRule":"evenodd","key":0}),React.createElement("path",{"stroke":"#fff","d":"M.5 8.789L14.722.577 28.945 8.79V25.21l-14.223 8.212L.5 25.21V8.79z","key":1})]);
}

Facebook.defaultProps = {"width":"30","height":"34","fill":"none","viewBox":"0 0 30 34"};

module.exports = Facebook;

Facebook.default = Facebook;
